import { render } from "./submission-tab-interests.vue?vue&type=template&id=0624e93b&scoped=true&ts=true"
import script from "./submission-tab-interests.vue?vue&type=script&lang=ts"
export * from "./submission-tab-interests.vue?vue&type=script&lang=ts"

import "./submission-tab-interests.vue?vue&type=style&index=0&id=0624e93b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0624e93b"]])

export default __exports__